import { styled } from '@mui/system';

const DivFlexStart = styled('div')((props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
}));

export default DivFlexStart;